import React from 'react';
import Box from '@mui/material/Box';
import { POK_AGGREGATE_RATING, POK_RATING_SOURCES } from '../utils/pokJsonLd.js';
import { INK, FG_2, FONTS, PURPLE } from './sections/theme.js';

/**
 * Visible attribution for POK_AGGREGATE_RATING. Required by Google's
 * structured-data guidelines: any page emitting aggregateRating in JSON-LD
 * must show a matching, sourced rating to users. Mounted once inside
 * FooterContainer so every page is covered.
 */
export function RatingBadge() {
    const total = POK_AGGREGATE_RATING.reviewCount;
    const rating = POK_AGGREGATE_RATING.ratingValue.toFixed(1);

    return (
        <Box
            component="aside"
            aria-label={`POK rating: ${rating} out of 5 from ${total} verified reviews`}
            sx={{
                width: '100%',
                textAlign: 'center',
                // Pull up into the footer's top padding so the badge sits close to the top edge.
                mt: { xs: '-1rem', sm: '-2.5rem' },
                mb: { xs: 2, sm: 3 },
                color: FG_2,
                fontFamily: FONTS.sans,
                fontSize: 13,
                lineHeight: 1.5,
            }}
        >
            <Box component="span" aria-hidden="true" sx={{ color: '#FFC444', fontSize: 15, letterSpacing: '1px' }}>
                ★★★★★
            </Box>{' '}
            <Box component="span" sx={{ fontWeight: 700, color: INK }}>
                {rating}
            </Box>{' '}
            from {total} verified reviews across{' '}
            {POK_RATING_SOURCES.map((src, idx) => {
                const isLast = idx === POK_RATING_SOURCES.length - 1;
                const isSecondLast = idx === POK_RATING_SOURCES.length - 2;
                return (
                    <React.Fragment key={src.name}>
                        <Box
                            component="a"
                            href={src.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{ color: PURPLE, textDecoration: 'underline' }}
                        >
                            {src.name}
                        </Box>
                        {!isLast && (isSecondLast ? ' & ' : ', ')}
                    </React.Fragment>
                );
            })}
        </Box>
    );
}
